import { render, staticRenderFns } from "./RequestActions.vue?vue&type=template&id=dc976f66&scoped=true&"
import script from "./RequestActions.vue?vue&type=script&lang=js&"
export * from "./RequestActions.vue?vue&type=script&lang=js&"
import style0 from "./RequestActions.vue?vue&type=style&index=0&id=dc976f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc976f66",
  null
  
)

export default component.exports